export enum PricelistTabs {
  DiscountTable = 'Discount Table',
  PrepAnalysis = 'Prep Analysis',
  AnalyteInfo = 'Analyte Info',
  AnalysisInfo = 'Analysis Info',
  SubAnalysis = 'Sub Analysis',
  GroupAnalysis = 'Group Analysis',
  MediaInfo = 'Media Info',
  OtherInfo = 'Other Info',
}
